import { isEmpty } from '@ember/utils';
import { validatePresence } from 'ember-changeset-validations/validators';

export default {
  fundIds: validatePresence({
    presence: true,
    message: 'At least one fund needs to be selected',
  }),
  emailTo: (key, newValue /*, oldValue, changes, content*/) => {
    if (isEmpty(newValue)) {
      return 'An email address needs to be entered';
    }
    if (newValue.length === 1 && isEmpty(newValue[0])) {
      return 'An email address needs to be entered';
    }
    newValue.forEach((item) => {
      if (isEmpty(item)) {
        return 'One of the email addresses entered is empty';
      }
    });
    return true;
  },
};
